import { Box, BoxProps, Img } from "@chakra-ui/react";
import logo from "../assets/logo.png";

interface LogoProps extends BoxProps {
  width?: number;
  height?: number;
}

export const Logo = ({ width = 100, height = 100, ...props }: LogoProps) => {
  return (
    <Box
      borderRadius={4}
      overflow={"hidden"}
      width={width}
      height={height}
      {...props}
    >
      <Img src={logo} width={width} height={height} />
    </Box>
  );
};
